import { render, staticRenderFns } from "./UserChangePasswordDialog.vue?vue&type=template&id=736976e6&"
import script from "./UserChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./UserChangePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports